export default defineNuxtRouteMiddleware((to) => {
  const hasTrailingSlash = to.path !== '/' && to.path.endsWith('/')

  if (hasTrailingSlash) {
    return navigateTo(to.path.slice(0, -1) + to.fullPath.slice(to.path.length), { redirectCode: 301 })
  }
})
